module.exports = __webpack_public_path__ + "static/media/wood3.30b96e55.jpg";